module.exports = require('./helpers/bundle-url').getBundleURL('hGepg') + "logo-dark.ba5147f0.svg";